import { render, staticRenderFns } from "./SectionTestimonials.vue?vue&type=template&id=58bb5af0&scoped=true&"
import script from "./SectionTestimonials.vue?vue&type=script&lang=js&"
export * from "./SectionTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./SectionTestimonials.vue?vue&type=style&index=0&id=58bb5af0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb5af0",
  null
  
)

export default component.exports